<template>

  <md-card :class="{ disabled }">
    <md-card-header>

      <div class="card-icon">
        <md-progress-spinner v-if="loading" md-mode="indeterminate" class="md-accent" :md-diameter="20" :md-stroke="3"></md-progress-spinner>
        <md-icon v-else>{{ icon }}</md-icon>
      </div>

      <div class="md-title">{{ title }}</div>
      <span style="margin-left: 6px;" v-if="tooltipText" >
        <md-tooltip
          :style="{ 'text-align': 'left', 'min-width': tooltipMinWidth+'px' }"
          :md-direction="tooltipDirection"
          v-html="tooltipText"
        >
        </md-tooltip>
        <md-icon>info</md-icon>
      </span>
      <div class="header-actions grow">
        <slot name="actions" />
      </div>

    </md-card-header>
    <md-card-content :class="{ padded }">
      <slot></slot>
    </md-card-content>
  </md-card>

</template>
<script>
import  GroupCardRow  from "./GroupCardRow.vue";

export default {
  name: "group-card",
  components: {
    GroupCardRow,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    showInfoIcon: {
      type: Boolean,
      default:true,
    },
    tooltipText: {
      type: String,
      default: ''
    },
    tooltipDirection: {
      type: String,
      default: 'top'
    },
    tooltipMinWidth: {
      type: String,
      default: '600'
    },
    icon: {
      type: String,
      default: "description",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    padded: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";
  @import "../../assets/scss/md-custom/_ausloans-colors.scss";
  .md-card{

    margin-bottom: 0px;

    & .md-card-header {
      display: flex;

      & .card-icon {
        background-color: $ausloans-blue-light !important;//$color-primary !important;
        width: 54px;
        height: 54px;

        & .md-icon{
          color: $color-text-on-dark;
        }

      }

      & .md-title {

      }

      & .header-actions {
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;

        &::v-deep .md-button:last-child{
          margin-right: initial;
        }

      }

    }

    & .md-card-content {
      padding-left: 5px;
      padding-right: 5px;

      &.padded
      {
        padding-left: 20px;
        padding-right: 20px;
      }

      &::v-deep:not(.padded) .padding
      {
        padding-left: 15px;
        padding-right: 15px;
      }

    }

    & .title {
      padding-bottom: 15px;
    }

  }

  // ::v-deep .md-card .card-icon

  ::v-deep .md-card-header .card-icon .md-progress-spinner svg *{
    stroke: $color-text-on-dark;
  }

  .disabled{
    opacity: 0.5;
    pointer-events: none;
  }
  table {
    border-collapse: collapse; /* Collapse table borders */
    width: 100%; /* Set table width */
  }
  td {
    padding: 10px; /* Apply padding to table cells */
    border: 1px solid #ddd; /* Add border for clarity */
  }

</style>
